<template>
  <van-popup v-model="isshow">
    <div class="down_popup">
      <div class="title">
        即将前往浏览器下载
      </div>
      <qrcode class="qrcode img" :value="downUrl"></qrcode>
      <sdkdow-btn ref="down" v-show="false"></sdkdow-btn>
      <single-button @know="download" :text="text" :width="width" :height="height"></single-button>
      <p @click="hide">再想想</p>
    </div>
  </van-popup>
</template>

<script>
import store from '@/store';
import qrcode from 'qrcode.vue';
import sdkdowBtn from './sdkdowBtn.vue';
import { downLoadUrl } from '@/utils/down'
export default {
  components: { sdkdowBtn, qrcode },
  name: 'VueNew39DownPopup',

  props: {
    text: {
      type: String,
      default: '立即下载'
    },
    url: {
      type: String,
      default: ''
    },
    isbg: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '11.7rem'
    },
    height: {
      type: String,
      default: '2rem'
    },
  },

  computed: {
    advertisingId() {
      return localStorage.getItem('advertisingId')
    },
    game_id() {
      return localStorage.getItem('sdkgame_id')
    },
    isIOS() {
      return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    },
    isAndroid() {
      return /(Android)/i.test(navigator.userAgent);
    },
    isPc(){
      return /(Windows)/i.test(navigator.userAgent);
    }
  },

  data() {
    return {
      isshow: false,
      type: '',
      downUrl: '',
    };
  },

  mounted() {
    this.downUrl = downLoadUrl()
  },

  methods: {
    download() {
      const sdkPageActive = store.state.community.sdkPageActive;
      var bundelId = ''
      if (this.isIOS) {
        bundelId = 'com.sjbox.ios'
      } else if (this.isAndroid) {
        bundelId = 'com.sjbox.az'
      }

      var sdkstartUrl = ''
      if (sdkPageActive && location.href.indexOf('/pages/sdkpage/index') != -1) {
        switch (sdkPageActive) {
          case 1:
            sdkstartUrl = `${bundelId}://communityData=/pages/index/gift/gift?id=${this.game_id}`
            break;
          case 2:
            sdkstartUrl = `${bundelId}://communityData=/pages/index/gamedetail/gamedetail?id=${this.game_id}`
            break;
          case 3:
            sdkstartUrl = `${bundelId}://communityData=/pages/community/community?id=${this.game_id}&sdktype=1`
            break;
          case 4:
            sdkstartUrl = `${bundelId}://communityData=/pages/yun/yun`
            break;
          case 5:
            sdkstartUrl = `${bundelId}://communityData=/pages/community/community?id=${this.game_id}`
            break;
        }
      } else {
        const data = location.pathname + location.search
        sdkstartUrl = `${bundelId}://communityData=${data}`
      }
      window.parent.postMessage({ event: 'openBox', download_url: this.downUrl, bundle_id: bundelId, startUrl: sdkstartUrl }, '*')
      console.log('startUrl', { event: 'openBox', download_url: this.downUrl, bundle_id: bundelId, startUrl: sdkstartUrl });
      // 判断不是iframe环境
      if (window.self == window.top) {
        window.open(this.downUrl)
      }
    },
    show() {
      this.isshow = true
    },
    hide() {
      this.isshow = false
    }
  },

  watch: {
    isshow(val) {
      if (val) {
        this.$nextTick(() => {
          if(location.pathname=='/pages/sdkpage/index' || this.type=='down') return
          this.$refs.down.download('open')
        })
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.van-popup {
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
}
.down_popup {
  width: 15.5rem;
  height: 14.3rem;
  background: linear-gradient(180deg, #ffffff 0%, #ffffff 100%);
  border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 1rem;
    font-weight: 700;
    margin: 0.9rem 0;
  }
  .img {
    width: 5.6rem;
    height: 5.6rem;
    margin-bottom: 0.9rem;
    ::v-deep canvas {
      width: 100% !important;
      height: 100% !important;
    }
  }
  p {
    color: #8e8e8e;
    margin-top: 0.8rem;
  }
}
</style>